import { Button } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { useTranslation } from 'react-i18next';

import { InfraAddForm } from '@/module/Laboratory/infra/InfraAddForm';
import { CenterReportCriteriaInfraRequest, useAddCenterReportCriteriaInfra } from '@/module/ResearchCenter';

import { Id, useAppNotification } from '@feature/utils';

export function InfraAddButton({ labId }: { labId: Id }) {
  const { mutate, isPending } = useAddCenterReportCriteriaInfra(labId);
  const { t } = useTranslation();
  const [opened, { open, close }] = useDisclosure(false);
  const notification = useAppNotification();

  const handleChange = (request: CenterReportCriteriaInfraRequest) =>
    mutate(request, {
      onError: notification.error,
      onSuccess: () => {
        notification.success();
        close();
      },
    });

  return (
    <>
      <Button
        size="xs"
        variant="outline"
        loading={isPending}
        onClick={open}
      >
        {t('button.add')}
      </Button>
      {opened && (
        <InfraAddForm
          onClose={close}
          isSubmitting={isPending}
          onChange={handleChange}
        />
      )}
    </>
  );
}
